import type { Tenant } from '@core/Entities/App/Tenants.entity';
import { getKenticoContent } from '@kentico/GetKenticoContent';

import type { CampaignBanner, HeroCampaignBanner } from '../Entities/CampaignBanner.entity';
import { removeInternalProps } from './RemoveInternalProps';

export const fetchHeroCampaignBanner = async (tenant?: Tenant) =>
  getKenticoContent<HeroCampaignBanner>('active_hero_campaign_banner', 4, 'uk', tenant);

export const shouldShowCampaignBanner = (
  activeHeroCampaignBanner: HeroCampaignBanner,
  page: string,
) =>
  activeHeroCampaignBanner?.campaign?.[0] &&
  activeHeroCampaignBanner?.pages.find(({ codename }: { codename: string }) => codename === page);

export const getCorrectBanner = (
  activeHeroCampaignBanner: HeroCampaignBanner,
  isEcom?: boolean,
  isD2c?: boolean,
) => {
  const { eComInvestorStockPageBanner, eComPageBanner, investorStockPageBanner, campaign } =
    activeHeroCampaignBanner;

  if (isEcom && isD2c && eComInvestorStockPageBanner?.[0])
    return removeInternalProps<CampaignBanner>(eComInvestorStockPageBanner?.[0]);
  if (isEcom && eComPageBanner?.[0])
    return removeInternalProps<CampaignBanner>(eComPageBanner?.[0]);
  if (isD2c && investorStockPageBanner?.[0])
    return removeInternalProps<CampaignBanner>(investorStockPageBanner?.[0]);
  return removeInternalProps<CampaignBanner>(campaign?.[0]);
};
